/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import DictApi from '@/api/dict';
import { InfoComplementField } from '../../types';

const style = require('./index.module.scss');

@Component({ name: 'MaritalStatus' })
export default class MaritalStatus extends Vue implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  /** 是否以select形式展示field */
  @Prop()
  private select: undefined | boolean;

  private maritalStatus: undefined | number | null = null;

  private errorMsg = '';

  private created() {
    if (this.value) {
      this.maritalStatus = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.maritalStatus) {
      this.maritalStatus = val;
    }
  }

  public onValidator(): boolean {
    if (this.maritalStatus === undefined || this.maritalStatus === null) {
      this.errorMsg = '请选择婚姻状况';
      return false;
    }

    return true;
  }

  private onChangeMarStatus(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.MaritalStatus}>
        <Field
          v-model={this.maritalStatus}
          label="婚姻状况"
          sub={true}
          onChange={() => this.onChangeMarStatus(this.maritalStatus)}
          type={this.select ? 'select' : 'pick'}
          dictApi={DictApi.getMarryTypes}
          error={this.errorMsg}
          readonly={true}
        />
      </div>
    );
  }
}
